import { render, staticRenderFns } from "./EtablishmentSheet.vue?vue&type=template&id=04ca74d0&scoped=true&"
import script from "./EtablishmentSheet.vue?vue&type=script&lang=js&"
export * from "./EtablishmentSheet.vue?vue&type=script&lang=js&"
import style0 from "./EtablishmentSheet.vue?vue&type=style&index=0&id=04ca74d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ca74d0",
  null
  
)

export default component.exports